<template>
  <div class="personal-data-page">
    <PersonalData />
  </div>
</template>

<script>
import PersonalData from "@/components/dashboard/pages/personal-data/PersonalData.vue";

export default {
  name: "LimeLoansPersonaldatapage",

  components: { PersonalData },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
